import { render, staticRenderFns } from "./step_description_lizing_ships.vue?vue&type=template&id=c3fcd90e&scoped=true"
import script from "./step_description_lizing_ships.vue?vue&type=script&lang=js"
export * from "./step_description_lizing_ships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fcd90e",
  null
  
)

export default component.exports